import { render } from "./GGoogle.vue?vue&type=template&id=49f9c854"
import script from "./GGoogle.vue?vue&type=script&lang=js"
export * from "./GGoogle.vue?vue&type=script&lang=js"
script.render = render

export default script